export interface Credit {
  amount: string;
  label: string;
  pricePerImage?: number;
  monthlyPrice?: number;
  yearlyPrice?: number;
  monthlyPricePerImage?: number;
  yearlyPricePerImage?: number;
}

// 更新价格格式化函数，移除小数部分
export function formatPrice(price: number | undefined) {
  if (price === undefined) return '$0';
  return `$${Math.floor(price) === price ? price : price.toFixed(2).replace(/\.?0+$/, '')}`;
}
